import React from "react";

export function PageHead({ crumb, title, sub, actions }) {
  return (
    <div className="page-head">
      <div>
        {crumb && <div className="crumb">{crumb}</div>}
        <h1 data-testid="page-title">{title}</h1>
        {sub && <div className="ph-sub">{sub}</div>}
      </div>
      {actions && <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>{actions}</div>}
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return <div className="empty" data-testid="loader">{label}</div>;
}

export function EmptyState({ icon: Icon, children }) {
  return (
    <div className="card pad">
      <div className="empty">
        {Icon && <Icon size={28} style={{ margin: "0 auto 10px" }} />}
        <div>{children}</div>
      </div>
    </div>
  );
}
